export default __webpack_public_path__ + "static/media/Shadow's Wristbands of the Deceiver.acbff00c.jpg";